export const validateRUT = (rut: string): boolean => {
  if (!rut) return false
  // Eliminar puntos y guiones
  const cleanRUT = rut.replace(/[.-]/g, '').toUpperCase()

  // Validar formato básico
  if (!/^\d{7,8}[0-9K]$/.test(cleanRUT)) {
    return false
  }

  const body = cleanRUT.slice(0, -1)
  const dv = cleanRUT.slice(-1)

  let sum = 0
  let multiplier = 2

  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body.charAt(i), 10) * multiplier
    multiplier = multiplier === 7 ? 2 : multiplier + 1
  }

  const calculatedDV = (11 - (sum % 11)) % 11
  const expectedDV = calculatedDV === 10 ? 'K' : calculatedDV.toString()

  return dv === expectedDV
}
